import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import { useLocation } from 'react-router-dom';
import { getWebsocketUrl, onWebsocketConnected, onWebsocketDisconnected, onWebsocketError, processMessage } from '../actions/websocket';

export default () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    const [pingInterval, setPingInterval] = useState();

    const didUnmount = useRef(false);

    const getWebSocketUrl = useCallback(() => dispatch(getWebsocketUrl()), []);

    const sendPing = () => {
        sendJsonMessage({ action: 'ping' });
    };

    const startPing = () => {
        if (!pingInterval) {
            setPingInterval(setInterval(sendPing, 30000));
        }
    };

    const stopPing = () => {
        clearInterval(pingInterval);
        setPingInterval();
    };

    const { sendJsonMessage, readyState } = useWebSocket(getWebSocketUrl, {
        onOpen: (event) => {
            dispatch(onWebsocketConnected(event));
            sendPing();
            startPing();
        },
        onClose: (event) => {
            dispatch(onWebsocketDisconnected(event));
            stopPing();
        },
        onMessage: (event) => dispatch(processMessage(event, pathname)),
        onError: (event) => dispatch(onWebsocketError(event)),

        share: false,

        shouldReconnect: () => {
            return didUnmount.current === false;
        },
        reconnectAttempts: 99999,
        reconnectInterval: 10000,
        retryOnError: true
    });

    useEffect(() => {
        return () => {
            stopPing();
            didUnmount.current = true;
        };
    }, []);

    return null;
};
